import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {createAction} from 'redux-actions';

export const locationChange = createAction('router/LOCATION_CHANGE');

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const AnalyticsProvider = ({children}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(locationChange(location));
  }, [location, dispatch]);

  return <>{children}</>;
};

const propTypes = {
  children: PropTypes.node
};

AnalyticsProvider.propTypes = propTypes;

export default AnalyticsProvider;
